import axios from "axios";

class Api {

  /**
   * Constructs a new Api object.
   */
  constructor() {
    const currentLanguage = document.documentElement.lang || "en";
    const baseURL = window.location.origin + '/api';

    this.client = axios.create({
      baseURL
    });
  }

  /**
   * Performs a request to a Drupal custom route.
   *
   * @param endpoint
   *   The endpoint for the requested entities.
   *
   * @param params
   *    The parameters for the request.
   *
   * @returns {Promise<unknown>}
   *   A promise for the response.
   */
  request(endpoint, params = {}) {
    const urlParams = new URLSearchParams();

    for(const [field, data] of Object.entries(params)) {
      urlParams.append(field, data);
    }

    return new Promise((resolve, reject) => {
      this.client.get(`${endpoint}${Object.keys(params).length ? "?" + urlParams.toString() : ""}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error);
        });
    });
  }

}

export default new Api;
